import React from "react";
import { Card } from "react-bootstrap";
import ProgressBar from "../../../Components/Progressbar";
import ReactECharts from "echarts-for-react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import './style.css';

interface DonutChartProps {
  value: string;
  color: string;
  label: string;
}

const DonutChart: React.FC<DonutChartProps> = ({ value, color, label }) => {
  const numericValue = Number(value) || 0;

  return (
    <div className="donutContainer">
      <div className="wrapper">
        <ResponsiveContainer className="reposivePieContainer">
          <PieChart>
            {/* Background Ring - no corners */}
            <Pie
              data={[{ value: 100 }]}
              cx="50%"
              cy="50%"
              innerRadius="80%"
              outerRadius="100%"
              startAngle={90}
              endAngle={-270}
              dataKey="value"
            >
              <Cell fill="#f4f4f4" />
            </Pie>

            {/* Foreground Progress Ring - rounded corners */}
            <Pie
              data={[{ value }]}
              cx="50%"
              cy="50%"
              innerRadius="80%"
              outerRadius="100%"
              startAngle={90}
              endAngle={90 - (360 * numericValue) / 100}
              dataKey="value"
              cornerRadius={20}
              isAnimationActive={false}
            >
              <Cell fill={color} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        {/* Center Label */}
        <div className="chartValue" >
          {value}%
        </div>
      </div>
      {/* Name Label */}
      <div className="chartLabel" >
        {label}
      </div>
    </div>
  );
};
interface ChartItem {
  planning: string;
  execution: string;
  reportingPhase: string;
}

interface AuditResponse {
  auditResponseQuality: {
    auditPriorityGood: number;
    auditPriorityOk: number;
    auditPriorityBad: number;
  };
  auditResponseTime: {
    auditPriorityGood: number;
    auditPriorityOk: number;
    auditPriorityBad: number;
  };
}
interface ProgressMetricsCardProps {
  overAllCompletion: string;
  taskCompletion: AuditResponse[];
  phaseWiseProgress: ChartItem[];
}



const ProgressMetricsCard: React.FC<ProgressMetricsCardProps> = ({
  overAllCompletion = "",
  taskCompletion =[],
  phaseWiseProgress = 0,
}) => {

  const getBarPosition = () => {
    const data = taskCompletion[0];

    const option = {
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          return `<strong>${params.name}</strong><br/>${params.seriesName} - ${params.value}`;
        },
      },
      legend: {
        top: 15,
        right: 70,
        data: ["High", "Medium", "Low"],
      },
      xAxis: {
        type: "category",
        data: ["Quality Distribution", "Timely Distribution"],
      },
      yAxis: {},
      series: [
        {
          name: "High",
          type: "bar",
          data: [
            data?.auditResponseQuality?.auditPriorityBad,
            data?.auditResponseTime?.auditPriorityBad,
          ],
          itemStyle: { color: "#FDB36D" },
          label: { show: true, position: "top" },
          emphasis: { focus: "self" },
        },
        {
          name: "Medium",
          type: "bar",
          data: [
            data?.auditResponseQuality?.auditPriorityOk,
            data?.auditResponseTime?.auditPriorityOk,
          ],
          itemStyle: { color: "#F9E214" },
          label: { show: true, position: "top" },
          emphasis: { focus: "self" },
        },
        {
          name: "Low",
          type: "bar",
          data: [
            data?.auditResponseQuality?.auditPriorityGood,
            data?.auditResponseTime?.auditPriorityGood,
          ],
          itemStyle: { color: "#14E8F9" },
          label: { show: true, position: "top" },
          emphasis: { focus: "self" },
        },
      ],
    };
    return option;
  };
  return (
    <Card.Body className="m-0">
      <div className="overalltitle">Overall Completion:</div>
      <div className="d-flex align-items-center">
        <ProgressBar completionPercentage={overAllCompletion} />
      </div>
      <div className="d-flex">
        <div className="col-6 my-3">
          <div className="my-3 overalltitle" style={{ position: "absolute" }}>
            Response Metrics:
          </div>
          <ReactECharts option={getBarPosition()} />
        </div>
        <div className="col-6 my-3">
          <div className="my-3 overalltitle">Progress of Responses:</div>
          <div className="phaseContainer">
            {Array.isArray(phaseWiseProgress) &&
              phaseWiseProgress.map((progress, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center flex-wrap"
                  style={{ gap: "1rem" }}
                >
                  <DonutChart value={progress.planning} color="#A6C48A" label="Completion" />
                  <DonutChart value={progress.execution} color="#C6DC4E" label="Quality" />
                  <DonutChart value={progress.reportingPhase} color="#F4B74B" label="Timeliness" />
                </div>
              ))}

          </div>
        </div>
      </div>
    </Card.Body>
  );
};

export default ProgressMetricsCard;
